import { z } from "zod";
import { Currency, TaxInclusionType, TaxType } from "@/gql/graphql";

export const quoteLineItemValidation = z.object({
  lineItems: z.object({
    upsert: z
      .array(
        z.object({
          id: z.string().optional(),
          description: z.string().min(3, {
            message: "Description must be at least 3 characters long",
          }),
          quantity: z
            .number()
            .gte(0, { message: "Quantity cannot be negative" }),
          tax_type: z.nativeEnum(TaxType, {
            message: "Please select a valid tax type",
          }),
          unit_amount: z
            .number()
            .gte(0, { message: "Unit amount cannot be negative" }),
        }),
      )
      .min(1, { message: "At least one line item is required" }),
    delete: z.array(z.string()).optional(),
  }),
});

export const quoteValidation = z.object({
  payee: z.object({
    connect: z.string({
      message: "Payee is required",
    }),
  }),
  currency: z.nativeEnum(Currency, {
    message: "Please select a valid currency",
  }),
  tax_inclusion_type: z.nativeEnum(TaxInclusionType, {
    message: "Please select a valid tax inclusion type",
  }),
  quote_date: z
    .string({
      message: "Quote date is required",
    })
    .refine((val) => !isNaN(Date.parse(val)), {
      message: "Quote date must be a valid date",
    }),
  expiry_date: z
    .string({
      message: "Expiry date is required",
    })
    .refine((val) => !isNaN(Date.parse(val)), {
      message: "Expiry date must be a valid date",
    }),
  additional_notations: z.string().optional(),
  lineItems: quoteLineItemValidation.shape.lineItems,
});
